import { useTranslation } from "react-i18next";
import { LoginForm } from "../components/LoginForm";
import type { LoginFormFields } from "../schemes";

export type LoginPageProps = {
	readonly error?: string | null;
	readonly onLogin: (data: LoginFormFields) => void;
};

export function LoginPage({ error, onLogin }: LoginPageProps) {
	const { t } = useTranslation("auth");

	return (
		<div className="flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
			<div
				className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
				style={{
					backgroundImage: "url('/static/images/bg-01.jpg')",
				}}
			/>
			<div className="w-full max-w-sm md:max-w-2xl">
				<div className="flex flex-col gap-6">
					<LoginForm error={error} onLogin={onLogin} />
					<div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-primary">
						{t("login.footer")}
					</div>
				</div>
			</div>
		</div>
	);
}
